// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  padding-right: inherit !important;
}

.popup {
  position: fixed;
  top: 75px;
  right: 59px;
  width: 300px;
  height: 500px;
  background-color: white;
  transition: right 1s ease-in-out;
  z-index: 999;
  border-radius: 15px;
  box-shadow: 0px 10px 20px rgba(117, 117, 117, 0.1607843137);
  border: 1px solid rgba(0, 0, 0, 0);
  padding: 10px;
  overflow-y: scroll;
}

.popup::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.popup::-webkit-scrollbar-thumb {
  background: transparent;
}

.popup::-webkit-scrollbar-track {
  background: transparent;
}

.popup-content {
  display: flex;
  align-items: flex-start;
  padding: 10px;
  cursor: pointer;
  word-break: break-all;
}

.notification-text {
  font: normal normal normal 12px Manrope;
  color: #5a5f67;
}

.profile-icon {
  margin-right: 10px;
}

.timestamp {
  color: #bfbfbf;
  font: normal normal normal 10px Manrope;
}

@media only screen and (max-width: 600px) {
  .popup {
    right: 21px;
    transform: none;
  }
}
@media only screen and (max-width: 600px) {
  .amy-top-nav-button {
    display: none !important;
  }
  .w-101 {
    width: 168% !important;
  }
  .profile-item {
    margin-left: 34vmin;
  }
}
@media only screen and (max-width: 400px) {
  .phone-se {
    margin-right: 30px;
  }
  .profile-item {
    margin-left: 7vmin;
  }
}
.contain-1 {
  padding-right: 4% !important;
}

.css-xd8hqh-MuiPaper-root-MuiAppBar-root {
  background-color: #f2f2fa !important;
}

.css-1ixdh7s-MuiPaper-root-MuiAppBar-root {
  background-color: #1f1f26 !important;
}

@media only screen and (max-width: 414px) {
  .css-xd8hqh-MuiPaper-root-MuiAppBar-root {
    padding-right: 0px !important;
  }
  .css-1ixdh7s-MuiPaper-root-MuiAppBar-root {
    padding-right: 0px !important;
  }
}
.group-btn {
  border-color: rgb(103, 75, 255) !important;
}

@media only screen and (max-width: 898px) {
  .mob-search {
    display: none !important;
  }
  .phone-search {
    width: inherit;
  }
}
@media screen and (min-width: 401px) and (max-width: 450px) {
  .phone-search-1 {
    width: 172%;
  }
}
@media screen and (min-width: 450px) and (max-width: 559px) {
  .phone-search-2 {
    width: 173%;
  }
}
@media screen and (min-width: 560px) and (max-width: 599px) {
  .phone-search-3 {
    width: 147%;
  }
}
@media only screen and (max-width: 399px) {
  .phone-search-4 {
    width: 178%;
  }
}
.underlined {
  text-decoration: underline !important;
}

@media only screen and (max-width: 900px) {
  .media-900 {
    display: none;
  }
}
@media (max-width: 600px) {
  .icon-class {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/layout/header/primary-header.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;AACF;;AACA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gCAAA;EACA,YAAA;EACA,mBAAA;EACA,2DAAA;EACA,kCAAA;EACA,aAAA;EACA,kBAAA;AAEF;;AAAA;EACE,QAAA;EACA,SAAA;AAGF;;AAAA;EACE,uBAAA;AAGF;;AAAA;EACE,uBAAA;AAGF;;AADA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AAIF;;AAFA;EACE,uCAAA;EACA,cAAA;AAKF;;AAHA;EACE,kBAAA;AAMF;;AAJA;EACE,cAAA;EACA,uCAAA;AAOF;;AALA;EACE;IACE,WAAA;IACA,eAAA;EAQF;AACF;AANA;EACE;IACE,wBAAA;EAQF;EALA;IACE,sBAAA;EAOF;EAJA;IACE,mBAAA;EAMF;AACF;AADA;EACE;IACE,kBAAA;EAGF;EADA;IACE,kBAAA;EAGF;AACF;AAAA;EACE,4BAAA;AAEF;;AAAA;EAEE,oCAAA;AAEF;;AAAA;EAEE,oCAAA;AAEF;;AACA;EACE;IACE,6BAAA;EAEF;EAAA;IACE,6BAAA;EAEF;AACF;AAAA;EACE,0CAAA;AAEF;;AAAA;EACE;IACE,wBAAA;EAGF;EADA;IACE,cAAA;EAGF;AACF;AADA;EACE;IACE,WAAA;EAGF;AACF;AADA;EACE;IACE,WAAA;EAGF;AACF;AADA;EACE;IACE,WAAA;EAGF;AACF;AADA;EACE;IACE,WAAA;EAGF;AACF;AADA;EACE,qCAAA;AAGF;;AADA;EACE;IACE,aAAA;EAIF;AACF;AAFA;EACE;IACE,aAAA;EAIF;AACF","sourcesContent":["body {\n  padding-right: inherit !important;\n}\n.popup {\n  position: fixed;\n  top: 75px;\n  right: 59px;\n  width: 300px;\n  height: 500px;\n  background-color: white;\n  transition: right 1s ease-in-out;\n  z-index: 999;\n  border-radius: 15px;\n  box-shadow: 0px 10px 20px #75757529;\n  border: 1px solid #00000000;\n  padding: 10px;\n  overflow-y: scroll;\n}\n.popup::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.popup::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n.popup::-webkit-scrollbar-track {\n  background: transparent;\n}\n.popup-content {\n  display: flex;\n  align-items: flex-start;\n  padding: 10px;\n  cursor: pointer;\n  word-break: break-all ;\n}\n.notification-text {\n  font: normal normal normal 12px Manrope;\n  color: #5a5f67;\n}\n.profile-icon {\n  margin-right: 10px;\n}\n.timestamp {\n  color: #bfbfbf;\n  font: normal normal normal 10px Manrope;\n}\n@media only screen and (max-width: 600px) {\n  .popup {\n    right: 21px;\n    transform: none;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .amy-top-nav-button {\n    display: none !important;\n  }\n\n  .w-101 {\n    width: 168% !important;\n  }\n\n  .profile-item {\n    margin-left: 34vmin;\n  }\n}\n// .form-spacing {\n//   margin-left: -14px;\n// }\n@media only screen and (max-width: 400px) {\n  .phone-se {\n    margin-right: 30px;\n  }\n  .profile-item {\n    margin-left: 7vmin;\n  }\n}\n\n.contain-1 {\n  padding-right: 4% !important;\n}\n.css-xd8hqh-MuiPaper-root-MuiAppBar-root {\n  //   padding-right: 0px !important;\n  background-color: #f2f2fa !important;\n}\n.css-1ixdh7s-MuiPaper-root-MuiAppBar-root {\n  //   padding-right: 0px !important;\n  background-color: #1f1f26 !important;\n}\n\n@media only screen and (max-width: 414px) {\n  .css-xd8hqh-MuiPaper-root-MuiAppBar-root {\n    padding-right: 0px !important;\n  }\n  .css-1ixdh7s-MuiPaper-root-MuiAppBar-root {\n    padding-right: 0px !important;\n  }\n}\n.group-btn {\n  border-color: rgb(103 75 255) !important;\n}\n@media only screen and (max-width: 898px) {\n  .mob-search {\n    display: none !important;\n  }\n  .phone-search {\n    width: inherit;\n  }\n}\n@media screen and (min-width: 401px) and (max-width: 450px) {\n  .phone-search-1 {\n    width: 172%;\n  }\n}\n@media screen and (min-width: 450px) and (max-width: 559px) {\n  .phone-search-2 {\n    width: 173%;\n  }\n}\n@media screen and (min-width: 560px) and (max-width: 599px) {\n  .phone-search-3 {\n    width: 147%;\n  }\n}\n@media only screen and (max-width: 399px) {\n  .phone-search-4 {\n    width: 178%;\n  }\n}\n.underlined {\n  text-decoration: underline !important;\n}\n@media only screen and (max-width: 900px) {\n  .media-900 {\n    display: none;\n  }\n}\n@media (max-width: 600px) {\n  .icon-class {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
